import { ROLES } from '@bb/users';
import type { AuthContextUser } from 'contexts';
import type { InPersonBookForType } from './types';

export const getBookForOptions = ({
  auth,
  isAdminWithAccess,
  hasElevatedAccess,
}: {
  auth: AuthContextUser;
  isAdminWithAccess: boolean;
  hasElevatedAccess?: boolean;
}): InPersonBookForType[] => {
  const result: InPersonBookForType[] = [];
  if (hasElevatedAccess) {
    result.push('otherAgent', 'customAgentCreate');
    if (isAdminWithAccess) {
      result.push('nonAgent', 'nonAgentCreate');
    } else if (!auth.isUnverified) {
      result.push('self');
    }
  } else {
    if (ROLES[auth.role] > ROLES.AGENT) {
      result.push('otherAgent');
    }
    if (!auth.isUnverified) {
      result.push('self');
    }
  }
  return result;
};

/**
 * Convert a time string to the minute of the day
 * @example
 * getTimeSlotNumberFromString("5:45 AM") === 345
 * getTimeSlotNumberFromString("7:30 PM") === 1170
 */
export const getTimeSlotNumberFromString = (timeSlotStr: string) => {
  const timeRegex = /(?<hour>\d+):(?<minute>\d+) (?<meridian>[A,P]M)/;
  const matches = timeRegex.exec(timeSlotStr);
  if (!matches?.groups) return 0;
  const { hour, minute, meridian } = matches.groups;
  return +minute + (+hour % 12) * 60 + (meridian === 'AM' ? 0 : 60 * 12);
};
